let VIDEO_URL;
let VIDEO_MARKER;
let VIDEO_MANAGER;
let loginUrl='https://app-fzpub.jiaoyanyun.com/school-fzpub'
let baseUrl = "https://app-fzpub.jiaoyanyun.com/xiaojiangshi-fz";
/* 环境变量 */
function envConfig() {
  console.log("process.env.env_config", process.env.env_config);
  if (
    process.env.env_config == "dev" ||
    process.env.env_config == "development"
  ) {
    VIDEO_URL = "https://videocut-dev.jiaoyanyun.com";
    VIDEO_MARKER = "https://toolplugin-dev.jiaoyanyun.com";
    VIDEO_MANAGER = "https://videomanager-dev.jiaoyanyun.com";
    // VIDEO_URL = 'http://10.25.6.146:8888';
  } else if (process.env.env_config == "fz") {
    VIDEO_URL = "https://videocut-fz.jiaoyanyun.com";
    VIDEO_MARKER = "https://toolplugin-fz.jiaoyanyun.com";
    VIDEO_MANAGER = "https://videomanager-fz.jiaoyanyun.com";
  } else if (process.env.env_config == "pre") {
    VIDEO_URL = "https://videocut-pre.jiaoyanyun.com";
    VIDEO_MARKER = "https://toolplugin-pre.jiaoyanyun.com";
    VIDEO_MANAGER = "https://videomanager-pre.jiaoyanyun.com";
  } else if (
    process.env.env_config == "prod" ||
    process.env.env_config == "production"
  ) {
    VIDEO_URL = "https://videocut.jiaoyanyun.com";
    VIDEO_MARKER = "https://toolplugin.jiaoyanyun.com";
    VIDEO_MANAGER = "https://videomanager.jiaoyanyun.com";
    baseUrl = "https://app-pub.jiaoyanyun.com/xiaojiangshi-pub";
    loginUrl="https://app-pub.jiaoyanyun.com/school-pub"
  }
}

envConfig();
let apiData = {
  questionDetail: `${VIDEO_URL}/cut-video/question/list`,
  userInfo: `${VIDEO_URL}/api/ts/wechat/user/get`, //获取用户信息
  updateUserInfo: `${VIDEO_URL}/api/ts/wechat/user/modifyGrade`, //更新用户信息
  collect: `${VIDEO_URL}/api/ts/favorites/add`, //题目、试卷、视频收藏
  cancelCollect: `${VIDEO_URL}/api/ts/favorites/remove`, //题目、试卷、视频收藏
  recommend1: `${VIDEO_URL}/api/ts/algorithm/recommend1`, //首页推荐接口
  recommend: `${VIDEO_URL}/api/ts/algorithm/recommend`, //首页推荐接口
  cardList: `${VIDEO_URL}/api/ts/card/getCard`, //获取卡片列表
  cardDetail: `${VIDEO_URL}/api/ts/card/getItem`, //获取卡片详情
  cardItemList: `${VIDEO_URL}/api/ts/card/getItemById`,
  search: `${VIDEO_URL}/api/ts/algorithm/search`, //综合搜索
  examAnalysis: `${VIDEO_URL}/api/ts/algorithm/paper/overview`, //试卷分析
  examDetail: `${VIDEO_URL}/api/ts/algorithm/paper/queryExamPaperElementList`, //试卷详情
  catalogueTabList: `${VIDEO_URL}/api/ts/algorithm/base/queryCatalogueTabList`, //查询教材标签
  knowledgeDetail: `${VIDEO_URL}/api/ts/algorithm/base/queryLabelKnowTreeByLkcId`, //获取知识点详情
  chapterList: `${VIDEO_URL}/api/ts/algorithm/base/queryCatalogueKnowList`, //获取教材章节列表
  searchSuggest: `${VIDEO_URL}/api/ts/algorithm/base/suggest`, //搜索联想
  videoDetail: `${VIDEO_URL}/api/ts/algorithm/video/getVideoUrls`, //查询视频信息
  examSnapShot: `${VIDEO_URL}/api/ts/card/getPaperSnapshotByIdList`, //获取试卷列表快照
  videoSnapShot: `${VIDEO_URL}/api/ts/card/getVideoContentByIdList`, //获取视频列表快照
  getPaperContentById: `${VIDEO_URL}/api/ts/card/getPaperContentById`, //获取卡包试卷详情--比较快
  questionSnapShot: `${VIDEO_URL}/api/ts/card/getByCardIdAndBizIdList`, //获取试题卡包列表
  examQuestionListByType: `${VIDEO_URL}/api/ts/card/paper/question`, //试卷里根据题目类型获取题目列表
  userView: `${VIDEO_URL}/api/ts/card/addUserView`, //增加用户浏览量
  UserBehavior: `${VIDEO_URL}/api/ts/algorithm/base/uploadUserBehavior`, //用户行为上报
  favouriteSnapShot: `${VIDEO_URL}/tss/api/favorite/getByDate`, //学科筛选收藏列表
  favouriteListOfData: `${VIDEO_URL}/tss/api/favorite/getBySubject`, //获取某日收藏详情列表
  catalogueTabList_part: `${VIDEO_URL}/api/ts/algorithm/base/queryCatalogueTabList1`, //获取教材版本——首页推荐
  paragraphDetail: `${VIDEO_URL}/api/ts/algorithm/paragraph/query`, //文段详情
  experimentList: `${VIDEO_URL}/api/ts/experiment/list`, //实验列表
  experimentDetail: `${VIDEO_URL}/api/ts/experiment/getById`, //实验详情
  wxSignature: `${VIDEO_URL}/api/ts/signature`, //获取微信签名信息
  xjsSignature: `${VIDEO_URL}/api/ts/xjsSignature`, //获取晓讲师微信签名信息

  //晓讲师分享
  share_videoDetail: `${VIDEO_MARKER}/api/plugin/video-tool/videoInfo`, //分享页获取视频详情
  share_viewCount: `${VIDEO_MARKER}/api/xjs/applicant/view`, //分享页-更新视频浏览量
  share_likeCount: `${VIDEO_MARKER}/api/xjs/works/like`, //分享页-更新视频点赞量
  share_urlShortCut: `${VIDEO_MARKER}/api/plugin/video-tool/url-shortcut`, //短链接
  share_queryFolder: `${VIDEO_MARKER}/api/plugin/video-tool/queryFolderForShare`, //分享页-查询文件夹
  share_queryPlugins: `${VIDEO_MARKER}/api/plugin/directory/pluginsForShare`, //分享页-查询文件夹内作品
  share_queryPlugins: `${VIDEO_MARKER}/api/plugin/directory/pluginsForShare`, //分享页-查询文件夹内作品
  share_getHomePageInfo: `${VIDEO_MARKER}//api/home/page/getHomePageInfo`, //分享页-查询

  //对接思维
  siwei_videoDetail: `${VIDEO_MANAGER}/api/video/selectByRandomId`,
  //新版视频详情接口
  newVideoInfo: `${baseUrl}/v1/share/getvideoinfo`,
  newQueryDir: `${baseUrl}/v1/share/getfolderlist`,
  newQueryVideo: `${baseUrl}/v1/share/getvideolist`,
  getUserInfo: `${baseUrl}/v1/share/getuserinfo`,
  addVideoViewCnt: `${baseUrl}/v1/statistics/view`,
  videoLike: `${baseUrl}/v1/statistics/like`,
  versionHistoryList: "/api/plugin/video-tool/getRevisionHistoryInfo", //查询晓讲师历史版本
  checkKey: `${baseUrl}/v1/share/precheck`,
  checkPsw: `${baseUrl}/v1/share/checkpassword`,
  getVideoById: `${baseUrl}/v1/share/getvideobyshareid`,
  getUserById: `${baseUrl}/v1/share/getuserbyshareid`,
  queryCreator: `${baseUrl}/v1/center/list`,
  newGetWxSign: `${baseUrl}/v1/share/getwxconfig`,
  checkCode:`${loginUrl}/v2/login/check-code`,
  userDetail:`${baseUrl}/v1/user/getinfo`,
  viewList:`${baseUrl}/v1/view/list`,
  clearallViewList:`${baseUrl}/v1/view/clear`,
  updateOrg: '/v1/user/updateLoginOrg',
};
export { apiData };



// WEBPACK FOOTER //
// ./src/js/API/api.js